import APP from '../config/config';

export const logoUrl = (municipality_id, file) => {
    const url = APP.apiUrl + `municipality/${municipality_id}/logo`;
    return file ? url + `?file=${file}` : url;
};
